import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { P } from '#app/components/typography/p.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'P',
}

const component: componentProps = {
	name: 'P',
	shortName: 'P',
	fileName: 'p',
	category: 'typography',
	description: ['Paragraph component.'],
	features: ['Drop-in replacement for the native <p> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<P>This is a paragraph.</P>`,
	styling: `.p {
	@apply text-fluid-md my-fluid-11 max-w-prose font-sans font-normal;
	&:last-child {
		@apply mb-0;
	}
}`,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const TextRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<P>This is a paragraph.</P>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default TextRoute
